<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <template v-if="advanced">-->
<!--              <a-col :md="4" :sm="24">-->
<!--                <a-form-item label="数据名" prop="title">-->
<!--                  <a-input v-model="queryParam.title" placeholder="请输入数据名" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->

<!--              <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>-->
<!--              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->

<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="时间筛选">-->
<!--                  <a-range-picker style="width: 100%" v-model="dateRange" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type='primary' @click='handleExport'>导出</a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :sexOptions="dict.type.sys_user_sex"
        :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable"
        @ok="getList"
      />
      <!-- 数据展示 -->

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>
        </span>
        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>

        <img slot="coverUrl" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrl" v-image-preview :src="record.coverUrl">

        <span slot="userStatus" slot-scope="text, record">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="record.status == 1" @change="changeIsOpen($event,record)"/>
        </span>
        
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>
        </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="vipOverTime" slot-scope="text, record">
          {{ parseTime(record.vipOverTime) }}
        </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" >
            <a-icon />详情
          </a>

        </span>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {delUser, changeIsOpen, getUserActionData} from '@/api/biz/userForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      userData: {},
      // 高级搜索 展开/关闭
      advanced: true,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      dateRange: [],
      // 查询参数
      queryParam: {
        beginTime: null,
        endTime: null,
        title: null,
        mobile: null,
        email: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => index + 1,
          align: 'center'
        },
        {
          title: '日期',
          dataIndex: 'time',
          align: 'center'
        },
        {
          title: 'app打开数',
          dataIndex: 'appOpen',
          align: 'center'
        },
        {
          title: 'app打开设备数',
          dataIndex: 'appOpenDeviceCount',
          align: 'center'
        },
        {
          title: '注册页面打开数',
          dataIndex: 'registerPageOpen',
          align: 'center'
        },
        {
          title: '注册页面打开设备数',
          dataIndex: 'registerPageDeviceCount',
          align: 'center'
        }

      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    // getList () {
    //   this.loading = true
    //   getVideoTotalData(this.queryParam).then(response => {
    //     this.list = response.data.records
    //     this.total = response.data.total
    //     this.loading = false
    //   })
    // },


    getList () {
      this.loading = true
      console.log(this.addDateRange(this.queryParam, this.dateRange))
      getUserActionData(this.addDateRange(this.queryParam, this.dateRange)).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        }
      )
    },
    // getUserTotalData() {
    //   getUserTotalData().then(response => {
    //     this.userData = response.data
    //   })
    // },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        videoName: undefined,
        email: undefined,
        nickname: undefined,
        isVip: undefined,
        invitationCode: undefined,
        showId: undefined,
        type: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    changeIsOpen (e,record) {
      record.status = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
          '操作成功'
        )
        return  record.status = e ? 1 : 0
      })
    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/app-feedbacks/userActionDataExport', {
            ...that.queryParam
          }, `站内基础埋点数据_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
